<template>
  <section>
    <h2>選擇要匯入的檔案</h2>
    <b-field>
      <b-upload
        v-model="dropFiles"
        drag-drop
        accept=".xls, .xlsx"
        :multiple="false"
        @input="addFile"
      >
        <section class="section">
          <div class="content has-text-centered">
            <p>
              <b-icon icon="upload" size="is-large"></b-icon>
            </p>
            <p>拖曳檔案過來 或者 點擊選擇檔案</p>
          </div>
          <!-- <b-button @click="addFile">import</b-button> -->
        </section>
      </b-upload>
    </b-field>

    <div class="tags">
      <span v-for="(file, index) in dropFiles" :key="index" class="tag is-primary">
        {{file.name}}
        <button class="delete is-small" type="button" @click="deleteDropFile(index)"></button>
      </span>
    </div>
    <p>上傳筆數(僅上傳已完成的資料): {{recordNum}}</p>
    <b-button v-if="recordNum > 0" @click="upload" type="is-primary">Upload</b-button>
    <b-table :data="sheetData" :columns="columns"></b-table>
  </section>
</template>

<script>
let api_url = process.env.VUE_APP_API_URL;


export default {
  name: "RecordImport",
  data() {
    return {
      dropFiles: [],
      sheetJson: null,
      sheetData: [],
      recordNum: 0,
      columns: [
          {field: "訂單號碼", label: "訂單號碼"},
          {field: "訂單日期", label: "訂單日期"},
          {field: "訂單狀態", label: "訂單狀態"},
          {field: "顧客", label: "顧客"},
          {field: "訂單小計", label: "訂單小計"},
          {field: "付款總金額", label: "付款總金額"},
          {field: "電話號碼", label: "電話號碼"},
      ]
    };
  },
  mounted() {
      let xlsxScript = document.createElement('script')
      xlsxScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.16.6/xlsx.min.js')
      document.head.appendChild(xlsxScript)
  },
  methods: {
    loadSheet() {
        this.sheetJson.forEach(element => {
            if (element['訂單狀態'] == '已完成') {
                this.sheetData.push(element);
            }
            
        });
        this.recordNum = this.sheetData.length;
        
    },
    upload() {
        // var data = fr.result;
        var xhr = new XMLHttpRequest();

        xhr.addEventListener("readystatechange", function () {
          if (this.readyState === 4) {
            console.log(this.responseText);
          }
        });

        xhr.open("POST", api_url + "/backend/import_record/");
        xhr.setRequestHeader("Content-Type", "application/json");
        console.log(this.sheetData)
        xhr.send(JSON.stringify({"data": this.sheetData}));
    },
    addFile() {
      console.log(this.dropFiles);
      let fr = new FileReader();
      console.log(fr);
      fr.onload =  () => {
        console.log("load down");
        console.log(fr);
        let  workbook = XLSX.read(fr.result, {type: 'binary'}); //XLSX: / xlsx.core.min.js read excel through XLSX.read(data, {type: type}) method
        console.log(workbook);
        let  sheetNames = workbook.SheetNames; // Sheet name collection
        console.log(sheetNames)
        let  worksheet = workbook.Sheets[sheetNames[0]]; // Here we only read the first sheet 
        console.log(worksheet)
        this.sheetJson = XLSX.utils.sheet_to_json(worksheet, {raw: false, defval:null}); 
        console.log(this.sheetJson)
        this.loadSheet();
      };
      fr.readAsBinaryString(this.dropFiles);
    //   fr.readAsText(this.dropFiles);
    // fr.readAsDataURL(this.dropFiles);
      // console.log(fr)
    },
    deleteDropFile(index) {
      this.dropFiles.splice(index, 1);
    },
  },
};
</script>